import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'src/app/components/shared/shared.module';
import { SharedReportsModule } from '../../shared/shared-reports.module';
import { GroupEdwComponent } from './group-edw/group-edw.component';
import { GroupForecastComponent } from './group-forecast/group-forecast.component';
import { LocationEdwComponent } from './location-edw/location-edw.component';
import { LocationForecastComponent } from './location-forecast/location-forecast.component';

@NgModule({
  declarations: [
    LocationForecastComponent,
    GroupForecastComponent,
    LocationEdwComponent,
    GroupEdwComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    SharedReportsModule,
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IdoModule {}
